/*eslint-disable*/
import React, { useState } from 'react'
import {
    Flex,
    PageWrapper,
    PageFooter,
    H1WithBack,
    Box,
    Button,
    CursorPointer,
} from '../../styling/GlobalStyles'
import { useDispatch } from 'react-redux'
import { NavBar } from '../../components/NavBar/NavBar'
import { AppDispatch } from 'store'
import { useNavigate } from 'react-router-dom'
import useFocusFirstInput from 'utils/useFocusFirstInput'
import { ISelectValue } from 'constants/globalTypes'
import { HonestSelectAsyncInput } from 'components/HonestAsyncSelect/HonestAsyncSelectInput'
import CalendarInput from 'components/CalendarInput/CalendarInput'
import { BodyText, OtherText } from 'styling/Typography'
import { Input } from 'components/Input/Input'
import RemoveCircle from 'assets/icons/RemoveCircle'
import { toast } from 'react-toastify'
import { CancelBtn } from 'components/Button/CancelBtn'
import { checkIn } from 'features/accommodation/accommodationSlice'

export const CheckIn: React.FC = () => {
    const [state, setState] = useState<ICheckInState>({
        users: [],
        guests: [],
        accommodation: null,
        startDate: null,
        numberOfNights: null,
    })
    const [addingEmployee, setAddingEmployee] = useState<ISelectValue>(null)
    const [addingGuest, setAddingGuest] = useState<IGuest>(null)
    const dispatch = useDispatch<AppDispatch>()
    const navigate = useNavigate()
    useFocusFirstInput()

    const addEmployee = () => {
        setState(prev => ({ ...prev, users: [...prev.users, addingEmployee] }))
        setAddingEmployee(null)
    }

    const parse = (data: any) => {
        return data.data.map((item) => ({ label: item.name, value: item.id }))
    }

    const handleSelect = (value: ISelectValue, name: string) => {
        setState({
            ...state,
            [name]: value,
        })
    }

    const handleDateTo = (date: Date) => {
        setState({
            ...state,
            startDate: date,
        })
    }

    const handleRemoveEmployee = (value: number) => {
        const filtered = state.users.filter(u => u.value !== value)
        setState(prev => ({ ...prev, users: filtered }))
    }

    const handleRemoveGuest = (id: string) => {
        const filtered = state.guests.filter(g => g.identificationNumber !== id)
        setState(prev => ({ ...prev, guests: filtered }))
    }

    const handleAddGuest = () => {
        if (state.guests.find(g => g.identificationNumber === addingGuest.identificationNumber)) {
            toast.warn('Guest with this identification number has already been added.')
            return
        }
        if (addingGuest && addingGuest.identificationNumber && addingGuest.firstName && addingGuest.lastName) {
            setState(prev => ({ ...prev, guests: [...prev.guests, addingGuest] }))
            setAddingGuest(null)
        } else {
            toast.warn('Please fill all guest fields before adding.')
        }
    }

    const handleSubmit = async () => {
        if (!state.accommodation) {
            toast.warn('Please select accommodation')
            return
        }
        if (!state.startDate) {
            toast.warn('Please select start date')
            return
        }
        if (!state.numberOfNights || state.numberOfNights <= 0) {
            toast.warn('Please enter a valid number of nights')
            return
        }

        const resp = await dispatch(checkIn(state))
        if (resp.meta.requestStatus === 'fulfilled') {
            navigate('/hr/accommodation')
        }
    }

    return (
        <>
            <NavBar />
            <PageWrapper>
                <Flex between center mb='16' >
                    <H1WithBack arrow title='Check In' />
                </Flex>
                <Flex width='100%' gap='1rem' >
                    <Flex column gap='1rem' width='100%'>
                        <HonestSelectAsyncInput
                            name='accommodation'
                            labelText='Accommodation'
                            onChange={handleSelect}
                            placeholder='Select Accomodation'
                            link='accommodation/management/accommodation'
                            parserFunction={parse}
                            defaultValue={state?.accommodation?.label}
                            nomarg
                        />
                        <CalendarInput
                            minDate={new Date()}
                            labelText='Start Date'
                            onChange={handleDateTo}
                            nomarg
                        />
                        <Input
                            labelText='Number of nights'
                            type='number'
                            name='numberOfNights'
                            placeholder='Enter number of nights'
                            value={state.numberOfNights || ''}
                            onChange={(e) => setState({ ...state, numberOfNights: Number(e.target.value) })}
                            nomarg
                        />
                        <Flex width='100%' >
                            <Flex width='100%' column gap='0.5rem' >
                                <BodyText weight='bold' >Assigned Employees:</BodyText>
                                <Flex column gap='0.5rem' >
                                    {state.users.length ? state.users.map(u => <Flex key={u.value} gap='3rem' >  <BodyText  >- {u.label}</BodyText> <CursorPointer onClick={() => handleRemoveEmployee(u.value)} ><RemoveCircle /></CursorPointer> </Flex>) : <OtherText>No employees added yet</OtherText>}
                                </Flex>
                            </Flex>
                            <Flex width='100%' column gap='0.5rem' >
                                <BodyText weight='bold' >Assigned Guests:</BodyText>
                                <Flex column gap='0.5rem' >
                                    {state.guests.length ? state.guests.map(g => <Flex key={g.identificationNumber} gap='3rem' >  <BodyText  >- ID:{g.identificationNumber} / {g.firstName} {g.lastName}</BodyText> <CursorPointer onClick={() => handleRemoveGuest(g.identificationNumber)} ><RemoveCircle /></CursorPointer> </Flex>) : <OtherText>No guests added yet</OtherText>}
                                </Flex>
                            </Flex>
                        </Flex>

                    </Flex>
                    <Flex column gap='1rem' width='100%'>
                        <Box width='100%' >
                            <BodyText style={{ marginBottom: '1rem' }} weight='bold' > Employees </BodyText>
                            <Flex width='100%' alignEnd gap='1rem' >
                                <HonestSelectAsyncInput
                                    nomarg
                                    link='users/basic'
                                    labelText='Employee'
                                    name='employee'
                                    onChange={(v) => setAddingEmployee(v)}
                                    defaultValue={addingEmployee?.label}
                                    parserFunction={(data: any) => data.data.map((i: any) => ({ label: i.fullName, value: i.id }))}
                                />
                                <Button orange onClick={addEmployee} >Add</Button>
                            </Flex>
                        </Box>
                        <Box width='100%' >
                            <BodyText style={{ marginBottom: '1rem' }} weight='bold' > Guests </BodyText>
                            <Flex width='100%' alignEnd gap='1rem' >
                                <Input
                                    name='id'
                                    placeholder='15'
                                    labelText='Identification Number'
                                    value={addingGuest?.identificationNumber || ''}
                                    onChange={(e) => setAddingGuest({ ...addingGuest, identificationNumber: e.target.value })}
                                    nomarg
                                />
                                <Input
                                    name='firstName'
                                    placeholder='John'
                                    labelText='First Name'
                                    value={addingGuest?.firstName || ''}
                                    onChange={(e) => setAddingGuest({ ...addingGuest, firstName: e.target.value })}
                                    nomarg
                                />
                                <Input
                                    name='lastName'
                                    placeholder='Doe'
                                    labelText='Last Name'
                                    value={addingGuest?.lastName || ''}
                                    onChange={(e) => setAddingGuest({ ...addingGuest, lastName: e.target.value })}
                                    nomarg
                                />
                                <Button orange onClick={handleAddGuest} >Add</Button>
                            </Flex>
                        </Box>
                    </Flex>
                </Flex>


            </PageWrapper>
            <PageFooter>
                <Flex gap='1rem'>
                    <CancelBtn />
                    <Button orange onClick={handleSubmit}>
                        Save
                    </Button>
                </Flex>
            </PageFooter>
        </>
    )
}


export interface ICheckInState {
    users: ISelectValue[];
    guests: IGuest[];
    accommodation: ISelectValue | null;
    startDate: Date | null;
    numberOfNights: number | null;
}

interface IGuest {
    identificationNumber: string
    firstName: string
    lastName: string
}